import React, { FC } from 'react'

import styles from './TeamTitle.module.scss'

interface TeamTitleProps {
  title: string
}

export const TeamTitle: FC<TeamTitleProps> = ({ title }) => {
  return <p className={styles.TeamTitle}>{title}</p>
}
